import React, { useRef, useState, useEffect } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  formatMoneda,
  formatoMonto,
  validaMonto,
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import useTableScroll from '../useTableScroll';
import CatalogoNotaCredito from '../../catalogos/catalogoNotadeCredito';
import CatalogoListAnticipos from '../../catalogos/catalogoAnticipos';
import CatalogoListRecibosdPagos from '../../catalogos/catalogoRecibosdePagos';

export const ModalImprimirRecibosdePago = (props) => {
  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const [searchText, setSearchText] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtBusqueda = useRef();
  const txtNumRecibo = useRef();
  const txtFechaPago = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState("");
  const [clienteSeleccionadoObj, setClienteSeleccionadoObj] = useState(null);
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [inputalmacen, setInputalmacen] = useState(0);
  const [inputproducto, setInputproducto] = useState(0);
  const [tiporif, setTipofic] = useState(null);
  const [valormon, setValormon] = useState(0.00);
  const [mostrar1, setMostrar1] = useState(null);
  const [mostrar2, setMostrar2] = useState(null);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [banco, setBanco] = useState([]);
  const [disponiblec, setDisponiblec] = useState('');
  const [numnota, setNumNota] = useState('');
  const [idclient, setIdclient] = useState('');
  const [simbol, setSimbol] = useState(null);
  const [combomoneda, setComboMoneda] = useState([]);
  const [activate, setActivate] = useState(false);
  const [idmoney, setIdmoney] = useState(0);
  const [tipofactu, setTipofactu] = useState("");
  const [valida, setValida] = useState(0);
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  // Efecto para cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest('.dropdown-container')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isDropdownOpen]);

  // Efecto para establecer fechas actuales cuando no hay cliente seleccionado
  useEffect(() => {
    if (mostrarFiltros && !clienteSeleccionado) {
      const hoy = moment().format('YYYY-MM-DD');
      setFechaDesde(hoy);
      setFechaHasta(hoy);
    }
  }, [mostrarFiltros, clienteSeleccionado]);

  const blanquear = () => {
    setActivate(false);
    setInputalmacen(0);
    setParafecha('');
    setDisponiblec('');
    setNumNota('');
    setInputproducto(0);
    setValida(0);
    setIdclient('');
    setIdmoney(0);
    setSimbol(null);
    setMostrar1(false);
    setMostrar2(false);
    setTipofactu("");
    setFechaDesde("");
    setFechaHasta("");
    setClienteSeleccionado("");
    setClienteSeleccionadoObj(null);
    setSearchText("");
    setIsDropdownOpen(false);
  }

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  // Función para manejar la selección del cliente
  const handleSelectCliente = (cliente) => {
    if (cliente === null) {
      setClienteSeleccionado("");
      setClienteSeleccionadoObj(null);
      setSearchText("");
      // Establecer fechas actuales cuando no hay cliente seleccionado
      const hoy = moment().format('YYYY-MM-DD');
      setFechaDesde(hoy);
      setFechaHasta(hoy);
    } else {
      setClienteSeleccionado(cliente.idagente);
      setClienteSeleccionadoObj(cliente);
      setSearchText(`${cliente.nombre} (${cliente.rif})`);
    }
    setIsDropdownOpen(false);
  };

  // Filtrar clientes basado en el texto de búsqueda
  const filteredClientes = clientes.filter(cliente =>
    cliente.nombre.toLowerCase().includes(searchText.toLowerCase()) ||
    cliente.rif.toLowerCase().includes(searchText.toLowerCase())
  );

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;

    if (props.ope === 1) {
      if (mostrarFiltros) {
        // Validar que si no hay cliente seleccionado, se usen las fechas actuales
        let desde = fechaDesde;
        let hasta = fechaHasta;

        if (!clienteSeleccionado) {
          const hoy = moment().format('YYYY-MM-DD');
          desde = hoy;
          hasta = hoy;
        }

        window.open(
          op.reportes + "/finanzas?afiliado=" + afiliado +
          "&reporte=ReporteRecibodePagoVarios" +
          "&IDCLIENTE=" + clienteSeleccionado +
          "&desde=" + desde +
          "&hasta=" + hasta,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        if (txtNombre.current.value === '' || txtRif.current.value === "" || txtNumRecibo.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: 'Notificación',
            texto: '¡ Seleccione y/o Introduzca el Número de Recibo !',
            icono: 'informacion'
          });
          txtNumRecibo.current.focus();
          sigue = false;
        } else {
          imprimirRecibo();
        }
      }
    }
  }

  const imprimirRecibo = () => {
    var reporte = "ReporteRecibodePago";
    let opera = 2;
    let condi = "'" + txtNumRecibo.current.value.trim() + "'";
    let tipo = tipofactu;
    window.open(
      op.reportes + "/finanzas?afiliado=" + afiliado +
      "&reporte=" + reporte +
      "&NUMPAGO=" + condi +
      "&OP=" + opera +
      "&TIPOPAGO=" + tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  }

  const handleAceptaDatosRecibo = (values) => {
    setMostrar2(false);
    txtNombre.current.value = values.nombre;
    txtRif.current.value = values.rif;
    txtNumRecibo.current.value = values.numpago;
    setTipofactu(values.tipo);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const seleccionarRegistros = (num) => {
    let endpoint = "";
    let tipo = 'porid';
    endpoint = `${op.conexion}/api/consulta/seleccionarrecibodepago?tipo=${tipo}&numpago=${num}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            txtNombre.current.value = response.data[0].nombre.trim();
            txtRif.current.value = response.data[0].rif;
            setTipofactu(response.data[0].tipofac.trim());
          } else {
            txtNombre.current.value = "";
            txtRif.current.value = "";
            txtNumRecibo.current.value = "";
            setTipofactu("");
            setMensaje({
              mostrar: true,
              titulo: 'Notificación',
              texto: '¡ Pago y/o N° de Recibo no Existe !',
              icono: 'informacion'
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "recibo") {
          seleccionarRegistros(event.target.value.toUpperCase());
        }
      }
    }
  };

  const seleccionarClintes = () => {
    let campos = "idagente, municipio, ciudad, trim(nombre) as nombre, trim(direccion) as direccion, rif, reprelegal, tipoper, idalmacen, celular";
    let nomtab = "agente";
    let condi = 'vendedor = false';
    let orden = "idagente";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setClientes(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarClintes();
  }, []);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => { }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Imprimir Recibo de Pago</h3></div>
        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' >
          <i className="fas fa-times fa-1x shadow"></i>
        </a>
      </Modal.Header>

      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })}
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>

        <div className='col-md-12 row mx-auto px-0'>
          <div className="col-md-12 mx-auto row px-0 mb-2" style={{ marginBottom: "10px" }}>
            <div className="row">
              <div className="input-group col-md-8 input-group-sm mb-3"></div>
              <div className="col-md-4 d-flex justify-content-end">
                <div className="form-check form-switch">
                  <label className="form-check-label mr-5" htmlFor="filtroSwitch">
                    Filtrar
                  </label>
                  <input
                    className="form-check-input mr-3"
                    type="checkbox"
                    role="switch"
                    id="filtroSwitch"
                    checked={mostrarFiltros}
                    onChange={(e) => {
                      setMostrarFiltros(e.target.checked);
                      if (!e.target.checked) {
                        // Resetear valores cuando se desactiva el filtro
                        setClienteSeleccionado("");
                        setClienteSeleccionadoObj(null);
                        setSearchText("");
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {mostrarFiltros ? (
            <div className="row mb-2 col-md-12 mx-auto px-0">
              <div className="col-md-12 dropdown-container position-relative">
                <label className="form-label">Cliente</label>

                {/* Input para búsqueda con dropdown */}
                <div className="input-group input-group-sm">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar cliente por nombre o RIF..."
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setIsDropdownOpen(true);
                    }}
                    onFocus={() => setIsDropdownOpen(true)}
                    onClick={() => setIsDropdownOpen(true)}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <i className={`fas fa-chevron-${isDropdownOpen ? 'up' : 'down'}`}></i>
                  </button>
                  {clienteSeleccionado && (
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => handleSelectCliente(null)}
                      title="Limpiar selección"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>

                {/* Dropdown de resultados */}
                {isDropdownOpen && (
                  <div
                    className="dropdown-menu show w-100"
                    style={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 1000,
                      position: "absolute",
                      top: "100%",
                      left: 0
                    }}
                  >
                    <div
                      className="dropdown-item text-muted"
                      onClick={() => handleSelectCliente(null)}
                      style={{ cursor: "pointer" }}
                    >
                      <small><i className="fas fa-times-circle mr-1"></i> Todos los clientes</small>
                    </div>

                    {filteredClientes.length > 0 ? (
                      filteredClientes.map(cliente => (
                        <div
                          key={cliente.idagente}
                          className="dropdown-item"
                          onClick={() => handleSelectCliente(cliente)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: clienteSeleccionado === cliente.idagente ? "#e9f7fe" : "white",
                            borderLeft: clienteSeleccionado === cliente.idagente ? "3px solid #007bff" : "3px solid transparent"
                          }}
                        >
                          <small>
                            <div><strong>{cliente.nombre}</strong></div>
                            <div className="text-muted">RIF: {cliente.rif}</div>
                          </small>
                        </div>
                      ))
                    ) : (
                      <div className="dropdown-item text-muted">
                        <small>No se encontraron clientes</small>
                      </div>
                    )}
                  </div>
                )}


              </div>

              <div className="col-md-6 mt-3">
                <label className="form-label">Fecha Desde</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={fechaDesde}
                  onChange={(e) => setFechaDesde(e.target.value)}
                  disabled={!clienteSeleccionado}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label className="form-label">Fecha Hasta</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={fechaHasta}
                  onChange={(e) => setFechaHasta(e.target.value)}
                  disabled={!clienteSeleccionado}
                />
              </div>

              {!clienteSeleccionado && (
                <div className="col-md-12 mt-3">
                  <div className="alert alert-info p-2 mb-0">
                    <small>
                      <i className="fas fa-info-circle mr-1"></i>
                      Al no seleccionar un cliente, se imprimirán todos los recibos de pago para las fechas seleccionadas.
                      Se usarán las fechas actuales por defecto.
                    </small>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="row col-md-12 rounded mx-auto m-0 border-azul px-1">
              <div className='col-12 row m-0 px-0 py-2'>
                <div className='col-pd-250 px-0 mb-1'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">N° RECIBO: </label>
                    <input
                      autoComplete='off'
                      type="text"
                      disabled={props.ope === 0 ? true : false}
                      name="recibo"
                      onKeyUp={handleInputNumeroChange}
                      onBlur={handleInputNumeroChange}
                      ref={txtNumRecibo}
                      className="form-control bg-transparent fs-6 text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button
                      type="button"
                      onClick={() => setMostrar2(true)}
                      disabled={props.ope === 0 ? true : false}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div className='col-pd-210 px-0 mb-1 ml-auto'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">RIF:</label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtRif}
                      name='rif'
                      className="form-control fs-6 text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>

                <div className='col-pd-480 px-0 mb-1'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">CLIENTE:</label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtNombre}
                      name='nombre'
                      className="form-control fs-6 text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button
              ref={btnAcepta}
              disabled={props.ope !== 0 ? false : true}
              onClick={onChangeValidar}
              className="btn btn-sm rounded-pill btn-primary mx-1"
            >
              <i className="fas fa-print">  Imprimir</i>
            </button>
            <button
              ref={btnCancela}
              onClick={cancelar}
              className="btn btn-danger btn-sm rounded-pill mx-1"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Footer>

      <CatalogoListRecibosdPagos
        show={mostrar2}
        tipo={'AN'}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaDatosRecibo}
      />
    </Modal>
  );
}


// WEBPACK FOOTER //
// ./src/components/finanzas/ImprimirRecibosdePagos.js